export function initWorks(){
    const tabs = document.querySelectorAll<HTMLAnchorElement>(".tab-work");
    const contents = document.querySelectorAll<HTMLElement>(".tab-work-content");

    tabs.forEach(tab => {
        tab.addEventListener("click", (e) => {
            e.preventDefault();

            // Снимаем active со всех
            tabs.forEach(t => t.classList.remove("active"));
            contents.forEach(c => c.classList.remove("active"));

            // Активируем текущий таб
            tab.classList.add("active");
            const id = tab.dataset.id;
            const content = document.querySelector<HTMLElement>(`.tab-work-content[data-content="${id}"]`);
            if (content) {
                content.classList.add("active");
            }
        });
    });
}